module.exports = __webpack_public_path__ + "static/expenseReport3-a647c798e167382633e84e759020d73f.png";